import { Button, Menu, MenuContent, MenuRadioGroup, MenuRadioItem, MenuTrigger } from '@cad-arc';
import { ElasticCobaltSortKeyEnumType, ElasticCobaltSortTypeEnumType } from '@mark43/cad-api';
import { adaptSelectOnChange } from '../forms/helpers/adapt-select-on-change';
import { Option } from '../forms/option';

type SortProps<T extends string> = {
    value: Option<T>;
    onChange: (value: Option<T>) => void;
    options: Option<T>[];
};

export function SortMenu({
    sortBy,
    direction,
    isDisabled,
}: {
    sortBy: SortProps<ElasticCobaltSortKeyEnumType>;
    direction: SortProps<ElasticCobaltSortTypeEnumType>;
    isDisabled?: boolean;
}): React.ReactElement {
    return (
        <Menu>
            <MenuTrigger asChild isDisabled={isDisabled}>
                <Button variant="ghost" disabled={isDisabled}>
                    Sort: {sortBy.value.label}
                </Button>
            </MenuTrigger>
            <MenuContent>
                <MenuRadioGroup
                    title="Sort By"
                    value={sortBy.value.value}
                    onValueChange={(value) =>
                        adaptSelectOnChange(
                            (e) => sortBy.onChange(e.target.value),
                            sortBy.options
                        )({ target: { value } })
                    }
                >
                    {sortBy.options.map((option) => (
                        <MenuRadioItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuRadioItem>
                    ))}
                </MenuRadioGroup>
                <MenuRadioGroup
                    title="Direction"
                    value={direction.value.value}
                    onValueChange={(value) =>
                        adaptSelectOnChange(
                            (e) => direction.onChange(e.target.value),
                            direction.options
                        )({ target: { value } })
                    }
                >
                    {direction.options.map((option) => (
                        <MenuRadioItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuRadioItem>
                    ))}
                </MenuRadioGroup>
            </MenuContent>
        </Menu>
    );
}
